import { addSnackBar, removeSnackBar, clearSnackBar } from './routines';

import { v4 as uuidv4 } from 'uuid';

export interface SnackBarsState {
  keys: string[];
  entities: Record<string, SnackBarItemState>;
}

export type SnackBarType = 'good' | 'bad' | 'warning';

export interface SnackBarItemState {
  readonly id: string;
  readonly name?: string;
  readonly type?: SnackBarType;
  readonly message: string;
  readonly headline?: string;
  readonly lifeTime: number; // Milliseconds
  readonly isLoading?: boolean;
  readonly actionLabel?: string;
  readonly reducerAction?: ReducerAction;
  readonly secondaryActionLabel?: string;
  readonly secondaryReducerAction?: ReducerAction;
}

export const getSnackBarState = (): SnackBarsState => ({
  keys: [],
  entities: {},
});

export default function (
  state = getSnackBarState(),
  action: ReducerAction
): SnackBarsState {
  if (!action) return state;
  switch (action.type) {
    case addSnackBar.TRIGGER: {
      if (!action.payload) return state;
      const id = action.payload.id || uuidv4();
      const snackBarItem: SnackBarItemState = {
        id,
        type: action.payload.type,
        name: action.payload.name,
        message: action.payload.message || '',
        headline: action.payload.headline,
        lifeTime: action.payload.lifeTime || -1,
        isLoading: action.payload.isLoading || false,
        actionLabel: action.payload.actionLabel,
        reducerAction: action.payload.reducerAction,
        secondaryActionLabel: action.payload.secondaryActionLabel,
        secondaryReducerAction: action.payload.secondaryReducerAction,
      };
      const entities = {
        ...state.entities,
        [id]: snackBarItem,
      };
      return {
        keys: [...state.keys, id],
        entities,
      };
    }
    case removeSnackBar.TRIGGER: {
      if (!action.payload) return state;
      const { payload } = action;
      const id: string = payload.id;
      const index = state.keys.findIndex((n) => n === id);
      const keys = [
        ...state.keys.slice(0, index),
        ...state.keys.slice(index + 1),
      ];
      const { [id]: kill, ...entities } = state.entities;

      return {
        keys,
        entities: {
          ...entities,
        },
      };
    }
    case clearSnackBar.TRIGGER:
      return getSnackBarState();
    default:
      return state;
  }
}
